import React, { useEffect, useState } from 'react'
import Meta from './layout/Meta'
import '../css/contact.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import helpers from '../helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import ContentLoader from 'react-content-loader';

export default function Contact() {
    // const mapurl = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6999.822789570878!2d77.150931!3d28.692297!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb75b763102d9b866!2sPES%20Installations%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1672141954930!5m2!1sen!2sin";
    const [pageloader, setPageloader] = useState(false);
    const [pagedata, setPagedata] = useState();
    const [contactlists, setContactlists] = useState([]);

    const [btnloader, setBtnloader] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [companyname, setCompanyname] = useState("");
    const [error, setError] = useState({ name: "", email: "", phone: "", message: "", companyname: "" });
    
    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/4')
                .then((response) => {
                    setPagedata(response.data.result);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [setPagedata]);

    useEffect(() => {
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/contacts')
                .then((response) => {
                    setContactlists(response.data.result.data);
                });
        }
        fetchData();
    }, [setContactlists]);

    async function ContactForm(e) {
        e.preventDefault();
        setBtnloader(true);
        setError({ name: "", email: "", phone: "", message: "", companyname: "" });
        let callback = { name: name, email: email, phone: phone, message: message, companyname: companyname }
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        await axios.post(process.env.REACT_APP_API + 'api/contactform', callback, config)
            .then((response) => {
                toast.success(response.data.message);
                setBtnloader(false);
                setName("");
                setEmail("");
                setPhone("");
                setCompanyname("");
                setMessage("");
            })
            .catch((errors) => {
                if (errors.response !== undefined) {
                    let rterror = errors.response.data.errors;
                    setError({
                        name: rterror?.name?.[0],
                        email: rterror?.email?.[0],
                        phone: rterror?.phone?.[0],
                        message: rterror?.message?.[0],
                        companyname: rterror?.companyname?.[0],
                    });
                    setBtnloader(false);
                }
            });
    }

    return (
        <>
            <Meta id={3} />
            <main>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Contact Us" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">Contact Us</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to={'/'}><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">Contact Us</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="Sec6 Contact">
                    <div className="container">
                        {
                            pageloader ?
                                <ContentLoader
                                    width={1600}
                                    height={600}
                                    backgroundColor="#f5f5f5"
                                    foregroundColor="#dbdbdb"
                                >
                                    <rect x="55" y="42" rx="16" ry="16" width="650" height="516" />

                                    <rect x="800" y="113" rx="3" ry="3" width="431" height="7" />
                                    <rect x="800" y="91" rx="3" ry="3" width="390" height="6" />
                                    <rect x="800" y="139" rx="3" ry="3" width="350" height="6" />
                                    <rect x="800" y="162" rx="3" ry="3" width="400" height="7" />
                                    <rect x="800" y="189" rx="3" ry="3" width="178" height="6" />
                                    <rect x="800" y="41" rx="3" ry="3" width="431" height="29" />

                                    <rect x="800" y="300" rx="3" ry="3" width="431" height="7" />
                                    <rect x="800" y="325" rx="3" ry="3" width="390" height="6" />
                                    <rect x="800" y="350" rx="3" ry="3" width="350" height="6" />
                                    <rect x="800" y="380" rx="3" ry="3" width="400" height="7" />
                                    <rect x="800" y="410" rx="3" ry="3" width="178" height="6" />
                                    <rect x="800" y="250" rx="3" ry="3" width="431" height="29" />

                                    
                                </ContentLoader>
                                :

                                <div className="row">
                                    <div className="col-12 col-lg-6 col-md-7">
                                        <form id="formsubmit" onSubmit={ContactForm}>
                                            <div className="row">
                                                <div className="col-12 mb-3">
                                                    <label htmlFor="Name" className="form-label m-0">Your Name <small className='text-danger'>*</small></label>
                                                    <input className="form-control" placeholder='Enter Your Name Here...' id="Name" value={name} onChange={(e) => setName(e.target.value)} type="text" />
                                                    {error.name ? <small className='error text-danger'>{error.name}</small> : ''}
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label htmlFor="Name" className="form-label m-0">Your Company Name</label>
                                                    <input className="form-control" placeholder='Enter Company Name Here...' id="Name" value={companyname} onChange={(e) => setCompanyname(e.target.value)} type="text" />
                                                    {error.companyname ? <small className='error text-danger'>{error.companyname}</small> : ''}
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label htmlFor="Email" className="form-label m-0">Your Email ID <small className='text-danger'>*</small></label>
                                                    <input className="form-control" placeholder='Enter Your Email Here...' id="Email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" />
                                                    {error.email ? <small className='error text-danger'>{error.email}</small> : ''}
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label htmlFor="Contact" className="form-label m-0">Your Contact No <small className='text-danger'>*</small></label>
                                                    <input className="form-control" placeholder='Enter Contact No Here...' id="Contact" value={phone} onChange={(e) => setPhone(e.target.value)} type="number" maxLength="10" />
                                                    {error.phone ? <small className='error text-danger'>{error.phone}</small> : ''}
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label htmlFor="Message" className="form-label m-0">Message <small className='text-danger'>*</small></label>
                                                    <textarea className="form-control" placeholder='Enter Message Here...' id="Message" value={message} onChange={(e) => setMessage(e.target.value)} ></textarea>
                                                    {error.message ? <small className='error text-danger'>{error.message}</small> : ''}
                                                </div>
                                            </div>
                                            {
                                                btnloader ?
                                                    <button type="button" className="btn btn-thm disabled"><FontAwesomeIcon icon={faSpinner} className="fa-spin me-1" /> Loading...</button>
                                                    :
                                                    <button type="submit" name="submit" className="btn btn-thm">Submit</button>
                                            }

                                        </form>
                                    </div>
                                    <div className="col-12 col-lg-6 col-md-5">
                                        {
                                            pagedata ?
                                                <div className="ConInfo ms-md-5">
                                                    <span className="SubTitle">{pagedata.title}</span>
                                                    <h2 className="Heading">{pagedata.heading}</h2>
                                                    <div dangerouslySetInnerHTML={{ __html: pagedata.description }} />
                                                    {
                                                        contactlists.length > 0 && contactlists.map((lists, ls) =>
                                                            <div key={ls}>
                                                                <h3 className="text-u mt-4 h5 thm border-top border-bottom pt-2 pb-1">{lists.title}</h3>
                                                                <ul className="mb-4">
                                                                    {
                                                                        lists.address ?
                                                                            <li><img src={require("../assets/img/location.svg").default} alt="Address" /> <span>{lists.address}</span></li>
                                                                            :
                                                                            ''
                                                                    }
                                                                    {
                                                                        lists.phone ?
                                                                            <li>
                                                                                <img src={require("../assets/img/call.svg").default} alt="Call" />
                                                                                <span>
                                                                                    {
                                                                                        helpers.helpers2(lists.phone).map((phones, ph) =>
                                                                                            <a key={ph} href={"tel:" + phones} className="d-block">{phones}</a>
                                                                                        )
                                                                                    }

                                                                                </span>
                                                                            </li>
                                                                            : ''
                                                                    }
                                                                    {
                                                                        lists.email ?
                                                                            <li>
                                                                                <img src={require("../assets/img/mail.svg").default} alt="Mail" />
                                                                                <span>
                                                                                    <a href="mailto:info@pesinstallations.com">{lists.email}</a>
                                                                                </span>
                                                                            </li>
                                                                            : ''
                                                                    }
                                                                </ul>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                :
                                                ''
                                        }

                                    </div>
                                </div>
                        }
                    </div>
                </section>
                {/* {
                    pageloader ?
                        <ContentLoader width={1600} height={450} backgroundColor="#f5f5f5" foregroundColor="#dbdbdb">
                            <rect x="20" y="42" rx="16" ry="16" width="1560" height="400" />
                        </ContentLoader>
                        :
                        <section className="map p-0">
                        {
                            mapurl ?
                            <iframe title="Address Map" src={mapurl} width="600" height="450" style={{ border: "0px" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                            : ''
                        }
                        </section>
                } */}
            </main>
        </>
    )
}
